var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0002 0.5C7.20999 0.5 5.4931 1.21116 4.22723 2.47703C2.96136 3.7429 2.2502 5.45979 2.2502 7.25V10.8515L0.804203 14.4725C0.758913 14.5862 0.742145 14.7093 0.755361 14.831C0.768578 14.9527 0.811377 15.0693 0.880024 15.1706C0.948671 15.272 1.04108 15.355 1.14918 15.4124C1.25729 15.4698 1.3778 15.4999 1.5002 15.5H16.5002C16.6226 15.4999 16.7431 15.4698 16.8512 15.4124C16.9593 15.355 17.0517 15.272 17.1204 15.1706C17.189 15.0693 17.2318 14.9527 17.245 14.831C17.2583 14.7093 17.2415 14.5862 17.1962 14.4725L15.7502 10.85V7.25C15.7502 5.45979 15.039 3.7429 13.7732 2.47703C12.5073 1.21116 10.7904 0.5 9.0002 0.5ZM9.0002 19.25C8.33498 19.2502 7.68858 19.0292 7.16262 18.6219C6.63667 18.2146 6.26101 17.6441 6.0947 17H11.9057C11.7394 17.6441 11.3637 18.2146 10.8378 18.6219C10.3118 19.0292 9.66542 19.2502 9.0002 19.25Z",
    fill: "#007696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.42d9bb6841b4fa4ff8e9aba7a9dd909d.svg";
export { ForwardRef as ReactComponent };